import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { AnimatedCar } from './AnimatedCar';
import { BannerContent } from './BannerContent';
import { GhostZero } from './GhostZero';
import { AnimatedLines } from './AnimatedLines';
import 'swiper/css';
import { banners } from './banner';

const ALIGNMENTS = {
    left: {
        wrapper: 'text-left',
        button: '',
    },
    center: {
        wrapper: 'text-center mx-auto',
        button: 'mx-auto',
    },
    right: {
        wrapper: 'text-right ml-auto',
        button: 'ml-auto',
    },
};



export default function BannerCarousel() {
    return (
        <Swiper
            modules={[Navigation, Autoplay]}
            loop
            autoplay={{
                delay: 6000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            }}
            className="w-full mt-24 md:mt-14"
        >
            {banners.map((banner, index) => (
                <SwiperSlide key={banner.id} className="relative">
                    {({ isActive }) => (
                        <div className="relative w-full h-[70vh] overflow-hidden">

                            {/* Background */}
                            <div
                                className="absolute inset-0 z-0 bg-black"
                                style={{
                                    backgroundImage: `url(${banner.bg})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            />

                            {/* Ghost ZERO */}
                            <GhostZero
                                isActive={isActive}
                                text={banner.ghost}
                                direction={banner.direction}
                            />

                            {/* Linhas animadas */}
                            <AnimatedLines
                                isActive={isActive}
                                accentColor={banner.accentColor}
                            />


                            {/* Texto */}
                            <div className="absolute inset-0 z-30 flex items-center">
                                <div className="container mx-auto px-6">
                                    <BannerContent
                                        isActive={isActive}
                                        titleSmall={banner.titleSmall}
                                        titleBig={banner.titleBig}
                                        cta={banner.cta}
                                        ctaLink={banner.ctaLink}
                                        accentColor={banner.accentColor}
                                    />
                                </div>
                            </div>

                            {/* Carro */}
                            <AnimatedCar
                                image={banner.car}
                                isActive={isActive}
                                direction={banner.direction}
                            />
                        </div>
                    )}
                </SwiperSlide>
            ))}
        </Swiper>
    );
}